<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true">
  <div modal-body>
    <div class="d-flex align-items-center flex-column mb-4">
      <span
        class="fa fa-check-circle text-success success-icon"
        aria-hidden="true"></span>
      <h3 class="fw-bold">{{ 'shared:licenses.requestQuoteModal.submit' | i18next }}</h3>
      <div class="text-center">{{ 'shared:licenses.requestQuoteModal.hint' | i18next }}</div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <div>
        @if (reseller.name) {
          <div class="text-center">
            <b>{{ reseller.name }} </b>
          </div>
        }
        <div class="text-center mt-2">
          <a href="mailto:{{ reseller.email }}">{{ reseller.email }}</a>
        </div>

        @if (reseller.phone) {
          <div class="text-center mt-2">
            <a href="tel:{{ reseller.phone }}">{{ reseller.phone }}</a>
          </div>
        }
      </div>
    </div>
  </div>

  <ng-container modalFooter>
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
